import React from 'react'

const FacturationPaiement = () => {
  return (
    <div>FacturationPaiement</div>
  )
}

export default FacturationPaiement